import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';

export const CareTeamViewWrapper = styled('div', {
  width: '100%',
  paddingBottom: '32px',
  paddingLeft: '$lg',
  paddingRight: '$lg',
  '.sticky-header': {
    position: 'sticky',
    top: 48,
    background: '#fff',
    zIndex: 1,
    paddingBottom: '10px',
    paddingTop: '32px',
  },
  '.container': {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '1200px',
  },
});

export const CareTeamDetailView = styled('div', {
  display: 'flex',
  paddingTop: '$md',
  paddingBottom: '$md',
  '@screen >= $md': {
    justifyContent: 'space-between',
  },
  '@screen < $md': {
    flexDirection: 'column',
    alignItems: 'center',
  },
});

export const CareTeamChipsContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  marginTop: '10px',
  paddingBottom: '16px',
});
export const ChipsDropdownStyle = {
  'abyss-dropdown-menu-trigger': {
    marginLeft: '10px',
    cursor: 'pointer',
  },
};
export const ChipButtonWrapper = {
  '&.abyss-button-root': {
    zIndex: 1,
    border: '1px solid $greyBorderColor',
    width: '150px',
    fontWeight: '$semibold',
    '@media (max-width: 1248px)': {
      marginRight: 0,
    },
  },
};
export const ButtonStyled = styled(Button, {
  dynamic: ({
    cssProps: {
      isSelected,
      selectedWrapperStyle,
      unselectedWrapperStyle,
      commonWrapperStyle,
    },
  }) => ({
    '&.abyss-button-root': {
      zIndex: 1,
      border: '1px solid $greyBorderColor',
      backgroundColor: isSelected ? '$lightBlue' : 'transparent',
      fontWeight: '$semibold',
      '@media (max-width: 1248px)': {
        marginRight: 0,
      },
      ...commonWrapperStyle,
      ...(isSelected ? selectedWrapperStyle : unselectedWrapperStyle),
    },
  }),
});

export const editPCPMenuStyle = {
  width: '72px',
  height: '18px',
  radius: '24px',
  border: 'none',
  backgroundColor: '$lightBlue',
  padding: '0',
  '.abyss-badge-root': {
    padding: '0',
  },
  '.abyss-badge-content': {
    fontSize: '12.64px',
    fontWeight: '700',
    fontStyle: 'normal',
    lineHeight: '16px',
    color: '$interactive1',
  },
  '.abyss-icon-material': {
    marginRight: '4px',
  },
};

export const CardGrid = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '24px',
  '@screen < $md': {
    gridTemplateColumns: 'repeat(1, 1fr)',
    justifyItems: 'center',
    width: '90%',
  },
});

export const ChoosePCPWrapper = styled('div', {
  display: 'flex',
  gap: '20px',
  '@screen >= $md': {
    flexDirection: 'row',
    marginRight: '20px',
  },
  '@screen < $md': {
    flexDirection: 'column',
    marginRight: '0px',
    justifyItems: 'center',
    width: '100%',
  },
});

export const PaginationWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',
});
